import _ from 'lodash';

export const formatCreditCardNumber = number => {
  if (!number) {
    return null;
  }

  const numberArray = Array.from(number);

  if (numberArray[0] === 'x') {
    return number;
  } else if (
    numberArray[0] === '3' &&
    (numberArray[1] === '4' || numberArray[1] === '7')
  ) {
    const numberNoDash = Array.from(number)
      .filter(digit => digit !== '-')
      .join('');

    const [firstTen, lastFive] = _.chunk(String(numberNoDash || ''), 10).map(
      chars => chars.join('')
    );

    const [firstTwo, secondTwo, thirdTwo, fourthTwo, fifthTwo] = _.chunk(
      String(firstTen || ''),
      2
    ).map(chars => chars.join(''));

    const joinfirstFour = [firstTwo, secondTwo].join('');
    const joinmiddleSix = [thirdTwo, fourthTwo, fifthTwo].join('');

    return [joinfirstFour, joinmiddleSix, lastFive]
      .filter(notNull => notNull)
      .join('-');
  }

  const numberNoDash = Array.from(number)
    .filter(digit => digit !== '-')
    .join('');

  const cc = _.chunk(String(numberNoDash || ''), 4)
    .map(chars => chars.join(''))
    .join('-');

  return cc;
};

export const removeDashesFromRxNumber = number => {
  const dashIndex = number.indexOf('-');
  if (number.includes('-')) {
    return number.slice(0, dashIndex);
  }
  return number;
};

export const removeNonNumbers = str => (str || '').replace(/[^0-9]/g, '');

export const numbersAndDashesOnly = str => (str || '').replace(/[^0-9 -]/g, '');

export const enableBodyScroll = () => {
  const target = document.body;
  target.className = '';
};

export const disableBodyScroll = () => {
  const target = document.body;
  target.className = 'modalOpen';
};

export const formatPhoneNumber = number => {
  if (!number) {
    return null;
  }
  const numberNoDash = Array.from(number)
    .filter(digit => digit !== '-')
    .join('');

  const [firstSix, lastFour] = _.chunk(String(numberNoDash || ''), 6).map(
    chars => chars.join('')
  );
  const [firstThree, middleThree] = _.chunk(String(firstSix || ''), 3).map(
    chars => chars.join('')
  );
  return [firstThree, middleThree, lastFour]
    .filter(notNull => notNull)
    .join('-');
};



// WEBPACK FOOTER //
// ./src/util.js